module.exports = __webpack_public_path__ + "static/media/JetMinds.fecfa69f.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/JetMinds.png
// module id = 790
// module chunks = 20